/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_CreateInputs */



/**
* | output |
* | --- |
* | "Couldn't create the tournament." |
*
* @param {Tournament_Error_CreateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_create = /** @type {((inputs?: Tournament_Error_CreateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_CreateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de créer le tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo crear el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível criar o torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile creare il torneo.")
	return /** @type {LocalizedString} */ ("Couldn't create the tournament.")
});